var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCloseAccount = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.5 10a5.52 5.52 0 0 1 5.315 4q.137.484.185 1H0a5.5 5.5 0 0 1 .186-1A5.52 5.52 0 0 1 5.5 10m0 1a4.52 4.52 0 0 0-4.266 3h8.532A4.52 4.52 0 0 0 5.5 11m0-9a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7m0 1a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M15.854 3.354 13.957 5.25l1.896 1.896-.707.708-1.896-1.897-1.896 1.897-.707-.708 1.896-1.896-1.896-1.896.707-.708 1.896 1.897 1.896-1.897z"
})));
export default SvgCloseAccount;